import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { StepperModule } from 'primeng/stepper';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';
import { collectInvalidControls } from '../../_utils/collect-invalid-controls';

export interface StepperFieldProps extends FormlyFieldProps {
  onNext: any;
  validationOnStep: boolean;
}

@Component({
  selector: 'stepper-field',
  standalone: true,
  imports: [...FORM_IMPORTS, StepperModule, ButtonModule, TranslatePipe],
  template: `
    <p-stepper [value]="0" [linear]="true">
      @for (
        step of field.fieldGroup;
        track step;
        let index = $index;
        let first = $first, last = $last
      ) {
        <p-step-item [value]="index">
          <p-step #steps>
            <ng-template
              #content
              let-activateCallback="activateCallback"
              let-value="value"
            >
              <button
                class="bg-transparent border-0 inline-flex flex-col gap-2"
                (click)="activateCallback()"
              >
                <span class="p-step-number">
                  {{ index + 1 }}
                </span>
              </button>
              <span
                class="{{
                  !isValid(step)
                    ? 'text-[var(--p-form-field-invalid-placeholder-color)] italic'
                    : ''
                }}"
                >{{ step.props?.label }}</span
              >
              <div>{{ step.props?.hidden }}</div>
              <small
                class="text-[var(--p-form-field-invalid-placeholder-color)] italic"
              >
                <formly-validation-message
                  class="ui-message-text"
                  [field]="step"
                ></formly-validation-message>
              </small>
            </ng-template>
          </p-step>
          <p-step-panel [value]="index">
            <ng-template #content let-activateCallback="activateCallback">
              @if (!first) {
                <div class="flex pb-6 flex-wrap gap-4">
                  <p-button
                    [label]="'stepper.back' | translate"
                    severity="secondary"
                    icon="fas fa-arrow-up"
                    (onClick)="activateCallback(index - 1)"
                  />
                </div>
              }

              <formly-field [field]="step"></formly-field>

              @if (!last) {
                <div class="flex pt-6 flex-wrap gap-4">
                  <p-button
                    [label]="'stepper.next' | translate"
                    icon="fas fa-arrow-down"
                    iconPos="right"
                    (onClick)="next($event, activateCallback, step, index)"
                  />
                </div>
              }
            </ng-template>
          </p-step-panel>
        </p-step-item>
      }
    </p-stepper>
  `,
  styles: `
    :host ::ng-deep {
      .p-stepitem .p-steppanel-content {
        width: calc(100% - 1rem);
      }
    }
  `,
})
export class StepperFieldType extends FieldType<
  FieldTypeConfig<StepperFieldProps>
> {
  @ViewChildren('steps') steps!: QueryList<ElementRef>;

  isValid(field: FormlyFieldConfig): boolean {
    if (field.key && field.formControl) {
      return field.formControl!.valid;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isValid(f))
      : true;
  }

  next(event: any, callback: any, step: FormlyFieldConfig, index: number) {
    // console.log(this.steps);

    // const s = this.steps.get(index + 1);
    // console.log(s);

    // if (s && s.nativeElement) {
    //   s.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // }

    if (
      this.props.validationOnStep != undefined ||
      this.props.validationOnStep == false
    ) {
      callback(index + 1);
      if (this.props.onNext) this.props.onNext(event);
    } else {
      if ((step.formControl as any).valid) {
        callback(index + 1);
        if (this.props.onNext) this.props.onNext(event);
      } else {
        collectInvalidControls(step.formControl!);

        // const controls = (step.formControl as any).controls;
        // Object.keys(controls).forEach((el) => {
        //   if (controls[el].invalid) {
        //     controls[el].markAsDirty();
        //     controls[el].markAllAsTouched();
        //   }
        // });
      }
    }
  }
}
